// import logo from './logo.svg';
// import './App.scss';
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams  } from "react-router-dom";
// import Routing from "./component/Routing/index";
// import {enableMapSet} from "immer"
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useDispatch, useSelector } from "react-redux";
// import { loginSuccess } from "../../cloud-menu-ui/src/redux/action";
// import { logoutSuccess } from  './redux/action';
// import FooterNav from "./component/FooterNav/index";
// import DrawerMenu from "./component/DrawerMenu/DrawerMenu"
// import WaiterRequest from  "./pages/WaiterRequestPage/WaiterRequest"
// import HeaderNavPage from './component/HeaderNav/HeaderNavPage';

// enableMapSet()
// function App() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { restaurant , id, table} = useParams();
//   const showPopup = useSelector((state) => state.session.showPopup);

//   useEffect(() => {
//     const savedUser = localStorage.getItem("user");
//     if (savedUser) { dispatch(loginSuccess({ user: JSON.parse(savedUser), redirectTo: "menu" })); }
//   }, [dispatch]);

//     const handleLogout = () =>
//   {
//          try
//          {
//             sessionStorage.clear();
//             localStorage.clear();
//             dispatch(logoutSuccess());
//             navigate(`/${restaurant}/${id}/${table}`);
//          } catch (error) {
//               console.error("Logot failed:", error.message);
//          }
//   };

//   return (
//     <div className="App">
//        <Routing />
//         <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         pauseOnHover
//         draggable
//       />
//       {/* ⏰ Session Timeout Popup */}
//       {showPopup && (
//         <div className="modal">
//           <div className="modal-content">
//             <h2>Session Expired</h2>
//             <p>Your session has timed out. Please log in again.</p>
//             <button className="logout" onClick={handleLogout}>Close</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default App;

import logo from "./logo.svg";
import { TableSessionProvider } from './component/TableSessionProvider';
import "./App.scss";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Routing from "./component/Routing/index";
import { enableMapSet } from "immer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "./redux/action";
import { logoutSuccess } from "./redux/action";
import FooterNav from "./component/FooterNav/index";
import DrawerMenu from "./component/DrawerMenu/DrawerMenu";
import WaiterRequest from "./pages/WaiterRequestPage/WaiterRequest";
import HeaderNavPage from "./component/HeaderNav/HeaderNavPage";

enableMapSet();
function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurant, id, table } = useParams();
  const showPopup = useSelector((state) => state.session.showPopup);

  useEffect(() => {
    const cachedTheme =
      localStorage.getItem("customer_portal_theme") || "default";
    document.documentElement.setAttribute("data-theme", cachedTheme);
  }, []);

  // 2. User Session Restore Hook
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      dispatch(
        loginSuccess({ user: JSON.parse(savedUser), redirectTo: "menu" }),
      );
    }
  }, [dispatch]);

  const handleLogout = () => {
    try {
      const allowedKeys = [
        "customer_portal_theme",
        "showBannerInLoginPage",
        "customer_portal_branch_id",
        "packageType",
      ];

      Object.keys(sessionStorage).forEach((key) => {
        if (!allowedKeys.includes(key)) {
          sessionStorage.removeItem(key);
        }
      });

      // 2. Clean LocalStorage (Yahan aapke tokens/user data hain)
      Object.keys(localStorage).forEach((key) => {
        if (!allowedKeys.includes(key)) {
          localStorage.removeItem(key);
        }
      });

      //  sessionStorage.clear();
      // localStorage.clear();

      // dispatch(logoutSuccess());
      navigate(`/${restaurant}/${id}/${table}`);
    } catch (error) {
      console.error("Logot failed:", error.message);
    }
  };

  return (
    <div className="App">
      <TableSessionProvider><Routing /></TableSessionProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
      {/* ⏰ Session Timeout Popup */}
      {showPopup && (
        <div className="modal">
          <div className="modal-content">
            <h2>Session Expired</h2>
            <p>Your session has timed out. Please log in again.</p>
            <button className="logout" onClick={handleLogout}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
